import { useState, useEffect, useContext } from "react";
import sendRequest from "hooks/useAxios";
import { sendRequest3 } from "hooks/useAxios";
import HashtagList from "components/HashtagBase/HashtagList";
import "../components/HashtagBase/hashtags.scss";
import "../components/store/addProductModal/AddProductModal.scss";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import Loader from "utils/Loader";
import { Slide } from "components/store/AmazingProduct";
import Pagination from "rc-pagination";
import { HiOutlineViewGridAdd } from "react-icons/hi";
import AddProductModal from "components/store/addProductModal/AddProductModal";
import EditProductModal from "components/SingleProduct/EditProductModal";
import ReactDOM from "react-dom";
import CartItemsContext from "context/CardItemsProvider";
import Search from "components/main/Search";
import { toast } from "react-toastify";
import oilLogo from "assets/images/Logos/New Project.png";

export default function Hashtags() {
  const auth = useContext(WithAuthentication);
  const isAdmin = auth.userInfo.userType == 0;
  const [hashtagList, setHashtagList] = useState([]);
  // const [selectedHashtag, setSelectedHashtag] = useState(-1);
  const [selectHashtags, setSelectHashtags] = useState([]);
  const [selectedEditProduct, setSelectedEditProduct] = useState({});
  const [productList, setProductList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const [tags, setTags] = useState([]);
  const {
    shoppingData,
    updateCartItem,
    cartItem,
    isLoading,
    setIsLoading,
    productUpdater,
    setProductUpdater,
    cartItemCounter,
    setCountUpdater,
    cartItemsCount,
  } = useContext(CartItemsContext);

  const [show, setShow] = useState(false);

  const firstCurrentPage = () => {
    setCurrentPage(1);
  };
  const hashtagHandler = (type, id) => {
    if (type == "all") {
      setSelectHashtags([]);
    } else if (type == "other") {
      !selectHashtags.includes(id)
        ? setSelectHashtags((prev) => {
            return [...prev, id];
          })
        : setSelectHashtags(selectHashtags.filter((s) => s != id));
    }
  };

  useEffect(() => {
    setIsLoading(true);
    // let temp = { tbl_name: `left join,files,coverimg_fileid,id` };
    // if (selectedHashtag != -1) {
    //   temp = {
    //     ...temp,
    //     conditions: `/exists/(SELECT * FROM products_hashtags_links WHERE (hashtag_id = ${selectedHashtag} AND products.id=products_hashtags_links.product_id))`,
    //   };
    // }
    let id = { hashtags: "" };
    // if (selectedHashtag != -1) {
    //   id = { hashtags: `${selectedHashtag}` };
    // }
    if (selectHashtags.length > 0) {
      id = { hashtags: `${selectHashtags.join(",")}` };
    }
    async function LoadPage() {
      await sendRequest("Find_hashtags").then((data) => {
        setHashtagList(data.data);
        setTags(data.data);
      });
      // await sendRequest("Find_products", temp).then((data) => {
      //   let temp = [...data.data];

      //   for (let i = 0; i < temp.length; i++) {
      //     temp[i] = { ...temp[i], cartItem_count: "0" };
      //   }

      //   setProductList(temp.reverse());
      //   setCountUpdater((prev) => !prev);
      // });
      await sendRequest3("getproduct", id).then((data) => {
        let temp = [...data.data.data];

        for (let i = 0; i < temp.length; i++) {
          temp[i] = { ...temp[i], cartItem_count: "0" };
        }

        setProductList(temp.reverse());
        setCountUpdater((prev) => !prev);
      });

      setIsLoading(false);
    }
    LoadPage();
  }, [selectHashtags, productUpdater]);

  return (
    <div className="hashtags-base mx-auto">
      {isLoading && <Loader />}
      {/* <div className="mt-4">
        {" "}
        <Search setSelectedHashtag={setSelectedHashtag} />
      </div> */}

      <div className="banner mx-auto mt-4 mb-2 d-flex">
        {" "}
        <div
          className="d-flex  m-2 my-auto line"
          style={{ border: "3px solid white", height: "90%" }}
        >
          <div
            className=" my-auto mx-2"
            style={{ height: "90%", borderRadius: 40 }}
          >
            <img
              src={oilLogo}
              className=" my-auto mx-2 mt-2"
              style={{ borderRadius: 40 }}
            />
          </div>

          <div style={{ height: "90%" }} className=" my-auto mx-3 py-3">
            {/* <h4>کاربرات</h4> */}
            <p className="five-line text-light">
              لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
              استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله
              در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد
              نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.
              کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان
              جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای
              طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان
              فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری
              موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد
              نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل
              دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.
            </p>
          </div>
        </div>
      </div>
      <HashtagList
        list={hashtagList}
        // selectedHashtag={selectedHashtag}
        // setSelectedHashtag={setSelectedHashtag}
        selectHashtags={selectHashtags}
        hashtagHandler={hashtagHandler}
        firstCurrentPage={firstCurrentPage}
      />

      {isAdmin && (
        <>
          <div className="d-flex justify-content-start">
            <button
              className="btn mx-3 "
              style={{
                backgroundColor: "#b61020",
                color: "white",
                borderRadius: "5px",
                fontSize: "13px",
              }}
              onClick={() => {
                setShow(true);
              }}
              // data-bs-toggle="modal"
              // data-bs-target="#addProductModal"
            >
              <HiOutlineViewGridAdd
                className="mx-1"
                style={{ width: 15, height: 15 }}
              />
              افزودن محصول
            </button>
          </div>
        </>
      )}
      <div className="d-flex flex-wrap products-list">
        {productList.length == 0 ? (
          <div className="mx-auto">
            در حال حاضر محصولی برای این دسته بندی وجود ندارد.
          </div>
        ) : (
          productList
            .slice((currentPage - 1) * 12, (currentPage - 1) * 12 + 12)
            .map((value) => {
              return (
                <div className=" col-xxl-2 col-md-3 col-sm-4  col-6 px-1 py-2">
                  <Slide
                    productDetail={{
                      ...value.product,
                      hashtags: value.hashtags,

                      cartItem_count:
                        cartItemCounter[`pid${value.product.id}`] == undefined
                          ? "0"
                          : cartItemCounter[`pid${value.product.id}`],
                      // value.cartItem_count
                    }}
                    type="hashtags"
                    isAdmin={isAdmin}
                    selectedEditProduct={selectedEditProduct}
                    setSelectedEditProduct={setSelectedEditProduct}
                    cartItem={cartItem}
                    updater={productUpdater}
                    setUpdater={setProductUpdater}
                    cartItemsCount={cartItemsCount}
                  />
                </div>
              );
            })
        )}
      </div>
      <div className="d-flex justify-content-center my-4">
        <div>
          <Pagination
            total={productList.length}
            pageSize={12}
            current={currentPage}
            onChange={(newPage) => {
              setCurrentPage(newPage);
            }}
          ></Pagination>
        </div>
      </div>
      {/* edit modal */}
      {/* {ReactDOM.createPortal( */}

      <AddProductModal
        setUpdater={setProductUpdater}
        tags={tags}
        show={show}
        setShow={setShow}
        navFirst="home"
      />
      {/* document.getElementById("addProduct") */}
      {/* )} */}
      {/* edit modal */}
      {ReactDOM.createPortal(
        <EditProductModal
          product={selectedEditProduct}
          tags={tags}
          setUpdater={setProductUpdater}
          // setUpdateProduct={setUpdateProduct}
        />,
        document.getElementById("editProduct")
      )}
    </div>
  );
}
